<div>
  <app-heading>{{ text }}</app-heading>
</div>

<div [style.position]="'relative'" [style.top.px]="-6">
  <ng-container [ngTemplateOutlet]="buttonTemplate"></ng-container>
</div>
